module.exports = __webpack_public_path__ + "img/gifiqr-billeder-legeplads.f498c178.jpg";